import React, { useState } from "react";

export default function Navigation() {
  const [isHovered, setIsHovered] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  // Inline responsive styles
  const navStyle: React.CSSProperties = {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "1.2rem 2.2rem",
    fontFamily: "Inter, Helvetica Neue, Arial, sans-serif",
    borderBottom: "1px solid #e5e7eb",
    background: "#fff",
    position: "sticky",
    top: 0,
    zIndex: 100,
  };

  const linksStyle = {
    display: "flex",
    gap: "2.2rem",
    alignItems: "center",
  };

  // Responsive: stack links below 500px
  const mediaQuery = `@media (max-width: 500px)`;
  const styleSheet = `
    ${mediaQuery} {
      .nav-links {
        flex-direction: column !important;
        gap: 1.2rem !important;
        align-items: flex-end !important;
        background: #fff;
        position: absolute;
        right: 1.2rem;
        top: 3.5rem;
        box-shadow: 0 2px 12px rgba(37,99,235,0.08);
        border-radius: 0.7rem;
        padding: 1rem 1.2rem;
        min-width: 120px;
        z-index: 200;
      }
      .nav-hamburger {
        display: inline-block !important;
      }
      .nav-links-collapsed {
        display: none !important;
      }
      .nav-brand {
        margin-bottom: 0 !important;
      }
      .nav-links a {
        text-decoration: none !important;
      }
    }
  `;

  return (
    <>
      <style>{styleSheet}</style>
      <nav style={navStyle}>
        <a
          href="#"
          className="nav-brand"
          style={{
            fontWeight: 900,
            fontSize: "1.6rem",
            color: "#18181b",
            letterSpacing: "-0.03em",
            fontFamily:
              "Montserrat Black, Poppins ExtraBold, Inter, Helvetica Neue, Arial, sans-serif",
            display: "inline-block",
            userSelect: "none",
            cursor: "pointer",
            transition: "transform 0.18s cubic-bezier(.4,2,.6,1)",
            transform: isHovered ? "scale(1.25)" : "scale(1)",
            textDecoration: "none",
            marginRight: "2.5rem",
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          aria-label="Back to top"
        >
          John
        </a>
        {/* Hamburger for small screens */}
        <button
          className="nav-hamburger"
          style={{
            display: "none",
            background: "none",
            border: "none",
            fontSize: "2rem",
            cursor: "pointer",
            marginLeft: "1.2rem",
            zIndex: 201,
          }}
          aria-label="Toggle navigation menu"
          onClick={() => setMenuOpen((open) => !open)}
        >
          &#9776;
        </button>
        <div
          className={menuOpen ? "nav-links" : "nav-links nav-links-collapsed"}
          style={linksStyle}
        >
          <a
            href="#about"
            style={{
              fontWeight: 600,
              color: "#374151",
              fontSize: "1.1rem",
              textDecoration: "none",
              transition: "color 0.18s",
            }}
            aria-label="About section"
          >
            About
          </a>
          <a
            href="#projects"
            style={{
              fontWeight: 600,
              color: "#374151",
              fontSize: "1.1rem",
              textDecoration: "none",
              transition: "color 0.18s",
            }}
            aria-label="Projects section"
          >
            Projects
          </a>
          <a
            href="#contact"
            style={{
              marginLeft: menuOpen ? 0 : "1.5rem",
              background: "#2563eb",
              color: "#fff",
              fontWeight: 500,
              fontSize: "0.98rem",
              border: "none",
              borderRadius: "0.5rem",
              padding: "0.45em 1.1em",
              textDecoration: "none",
              boxShadow: "0 1px 4px rgba(37,99,235,0.08)",
              transition: "background 0.18s, box-shadow 0.18s",
              cursor: "pointer",
              display: "inline-block",
            }}
            aria-label="Contact section"
            onMouseOver={(e) => (e.currentTarget.style.background = "#1d4ed8")}
            onMouseOut={(e) => (e.currentTarget.style.background = "#2563eb")}
          >
            Contact Me
          </a>
        </div>
      </nav>
    </>
  );
}
